import { render } from "./PagePowerCouplesSection.vue?vue&type=template&id=17d588a8"
import script from "./PagePowerCouplesSection.vue?vue&type=script&lang=js"
export * from "./PagePowerCouplesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__